import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';
import buttonFields from './helpers/buttonFields';

const MapLayer: IModel = {
  title: 'Map Layers',
  apiPath: 'system/map_layers',
  forms: {
    insert: {
      fields: [
        'map_id',
        'tenant_id',
        'ui_code',
        'ui_title',
        'ui_ttoken',
        'gs_layer_source',
        'gs_layer_type',
        'gs_url',
        'gs_layer',
        'gs_projection',
        'active',
        'gs_format',
        'ui_legend',
        'legend_conf_id',
        'ui_has_opacity_slider',
        { source: 'gfi_model_id', readonly: false },
        'layer_functionality_id',
        'module_id',
        'app_permission_id'

      ],
    },
    update: {
      fields: [
        'map_id',
        'tenant_id',
        'ui_code',
        'ui_title',
        'ui_ttoken',
        'description',
        'gs_layer_source',
        'gs_layer_type',
        'gs_url',
        'gfi_url_override',
        'gs_layer',
        'gs_projection',
        'ui_extent',
        'gs_styles',
        'gs_format',
        'gs_tiled',
        'gs_call_group',
        'gs_cql_filter',
        'ui_visible',
        'gs_can_query',
        'ui_zoomable',
        'ui_sortorder',
        'ui_z_index',
        'use_cache',
        'ui_parent_layer_code',
        'ui_offset_x',
        'ui_offset_y',
        'ui_style',
        'gs_timeseries',
        'gs_visible_min_zoom',
        'gs_visible_max_zoom',
        'ui_legend',
        'legend_conf_id',
        'ui_has_opacity_slider',
        { source: 'gfi_model_id', readonly: false },
        'layer_functionality_id',
        'module_id',
        'app_permission_id'
      ],
    },
    search: {
      fields: ['map_id', 'tenant_id', 'ui_code', 'ui_title']
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'map_id',
        'tenant_id',
        'ui_code',
        'ui_title',
        'ui_visible',
        'ui_z_index',
        'ui_sortorder',
        "gs_layer",
        "gs_layer_source",
        "gs_layer_type",
        "gs_can_query",
        "gfi_model_id",
        "layer_functionality_id",
         'current_app_permission_id',
        'copy',
      ],
      hidden: ["module_id"]
    },
  },
  fields: [
    coreFields.id,
    coreFields.created_on,
    coreFields.modified_on,
    buttonFields.copy,
    {
      title: 'map_id',
      source: 'map_id',
      ttoken: 'admin:layers.map_id',
      type: 'picker',
      subModel: {
        apiPath: 'system/maps',
        format: '{label}',
        idattr: 'id',
      },
      validation: {
        required: true,
      },
      filter: true,
      readonly: false,
      translate: false,
      tooltip: 'admin:layers.help.map_id',
    },
    {
      title: 'tenant_id',
      source: 'tenant_id',
      ttoken: 'admin:common.tenant_id',
      type: 'picker',
      filter: true,
      subModel: {
        apiPath: 'system/tenants?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      validation: {
        required: true,
      },
      tooltip: 'admin:layers.help.tenant_id',
    },
    {
      title: 'tenant_tag',
      source: 'tenant_tag',
      type: 'text',
      ttoken: '' // TODO
    },
    {
      title: 'ui_code',
      source: 'ui_code',
      ttoken: 'admin:common.code',
      type: 'text',
      filter: true,
      validation: {
        required: true,
        maxLength: 30,
      },
      tooltip: 'admin:layers.help.ui_code',
    },
    {
      title: 'ui_title',
      source: 'ui_title',
      ttoken: 'core:common.title',
      type: 'text',
      filter: true,
      validation: {
        maxLength: 250,
      },
      tooltip: 'admin:layers.help.ui_title',
    },
    {
      title: 'ui_ttoken',
      source: 'ui_ttoken',
      ttoken: 'admin:common.ttoken',
      type: 'text',
      validation: {
        required: true,
        maxLength: 50,
      },
      tooltip: 'admin:layers.help.ui_ttoken',
    },
    {
      title: 'description',
      source: 'description',
      ttoken: 'admin:layers.description',
      type: 'text',
      validation: {
        maxLength: 2000,
      },
      tooltip: 'admin:layers.help.description',
    },
    {
      title: 'gs_layer_source',
      source: 'gs_layer_source',
      ttoken: 'admin:common.source',
      type: 'picker',
      items: {
        labels: [
          'GROUP',
          'OSM',
          'VectorSource',
          'ImageWMS',
          'TileWMS',
          'WMTS',
          'TMS',
        ],
        values: [
          'GROUP',
          'OSM',
          'VectorSource',
          'ImageWMS',
          'TileWMS',
          'WMTS',
          'TMS',
        ],
      },
      validation: {
        maxLength: 20,
        required: true,
      },
      filter: true,
      tooltip: 'admin:layers.help.gs_layer_source',
    },
    {
      title: 'gs_layer_type',
      source: 'gs_layer_type',
      ttoken: 'core:common.type',
      type: 'picker',
      items: {
        labels: [
          'GROUP',
          'VectorLayer',
          'ImageLayer',
          'TileLayer',
          // 'WebGLTileLayer',
        ],
        values: [
          'GROUP',
          'VectorLayer',
          'ImageLayer',
          'TileLayer',
          // 'WebGLTileLayer',
        ],
      },
      validation: {
        maxLength: 20,
        required: true,
      },
      filter: true,
      tooltip: 'admin:layers.help.gs_layer_type',
    },
    {
      title: 'gs_url',
      source: 'gs_url',
      ttoken: 'core:common.url',
      type: 'text',
      validation: {
        maxLength: 250,
      },
      tooltip: 'admin:layers.help.gs_url',
    },
    {
      title: 'gfi_url_override',
      source: 'gfi_url_override',
      ttoken: 'admin:layers.gfi_url_override',
      type: 'text',
      tooltip: 'admin:layers.help.gfi_url_override',
    },
    {
      title: 'gs_layer',
      source: 'gs_layer',
      ttoken: 'core:common.layer',
      type: 'text',
      validation: {
        maxLength: 250,
      },
      filter: true,
      tooltip: 'admin:layers.help.gs_layer',
    },
    {
      title: 'gs_projection',
      source: 'gs_projection',
      ttoken: 'core:common.projection',
      type: 'text',
      validation: {
        maxLength: 10,
      },
      tooltip: 'admin:layers.help.gs_projection',
    },
    {
      title: 'ui_extent',
      source: 'ui_extent',
      ttoken: 'admin:layers.extent',
      type: 'array',
      tooltip: 'admin:layers.help.ui_extent',
    },
    {
      title: 'gs_styles',
      source: 'gs_styles',
      ttoken: 'admin:layers.styles',
      type: 'text',
      tooltip: 'admin:layers.help.gs_styles',
    },
    {
      title: 'gs_format',
      source: 'gs_format',
      ttoken: 'core:common.format',
      type: 'picker',
      items: {
        labels: [
          'image/png',
          'image/png8',
          'image/jpeg',
          'image/vnd.jpeg-png',
          'image/vnd.jpeg-png8',
          'image/gif',
          'image/tiff',
          'image/tiff8',
          'image/geotiff',
          'image/geotiff8',
          'image/svg',
          'application/pdf',
          'rss',
          'kml',
          'kmz',
          'application/openlayers',
          'application/json;type=utfgrid',
        ],
        values: [
          'image/png',
          'image/png8',
          'image/jpeg',
          'image/vnd.jpeg-png',
          'image/vnd.jpeg-png8',
          'image/gif',
          'image/tiff',
          'image/tiff8',
          'image/geotiff',
          'image/geotiff8',
          'image/svg',
          'application/pdf',
          'rss',
          'kml',
          'kmz',
          'application/openlayers',
          'application/json;type=utfgrid',
        ],
      },
      validation: {
        maxLength: 20,
      },
      tooltip: 'admin:layers.help.gs_format',
    },
    {
      title: 'gs_tiled',
      source: 'gs_tiled',
      ttoken: 'admin:layers.tiled',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      tooltip: 'admin:layers.help.gs_tiled',
    },
    {
      title: 'gs_call_group',
      source: 'gs_call_group',
      ttoken: 'admin:layers.call_group',
      type: 'text',
      validation: {
        maxLength: 20,
      },
      tooltip: 'admin:layers.help.gs_call_group',
    },
    {
      title: 'gs_cql_filter',
      source: 'gs_cql_filter',
      ttoken: 'admin:layers.cql_filter',
      type: 'text',
      validation: {
        maxLength: 200,
      },
      tooltip: 'admin:layers.help.gs_cql_filter',
    },
    {
      title: 'ui_visible',
      source: 'ui_visible',
      ttoken: 'admin:layers.visible',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: true,
      },
      tooltip: 'admin:layers.help.ui_visible',
    },
    {
      title: 'gs_can_query',
      source: 'gs_can_query',
      ttoken: 'admin:layers.can_query',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
      tooltip: 'admin:layers.help.gs_can_query',
    },
    {
      title: 'active',
      source: 'active',
      ttoken: 'core:common.active',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: true,
      },
      tooltip: 'admin:layers.help.active',
    },
    {
      title: 'ui_zoomable',
      source: 'ui_zoomable',
      ttoken: 'admin:layers.zoomable',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      tooltip: 'admin:layers.help.ui_zoomable',
    },
    {
      title: 'ui_sortorder',
      source: 'ui_sortorder',
      ttoken: 'core:common.sortorder',
      type: 'numeric',
      tooltip: 'admin:layers.help.ui_sortorder',
    },
    {
      title: 'ui_z_index',
      source: 'ui_z_index',
      ttoken: 'admin:layers.z_index',
      type: 'numeric',
      tooltip: 'admin:layers.help.ui_z_index',
    },
    {
      title: 'use_cache',
      source: 'use_cache',
      ttoken: 'admin:layers.use_cache',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      tooltip: 'admin:layers.help.use_cache',
    },
    {
      title: 'ui_parent_layer_code',
      source: 'ui_parent_layer_code',
      ttoken: 'admin:layers.parent_layer_code',
      type: 'text',
      validation: {
        maxLength: 30,
      },
      tooltip: 'admin:layers.help.ui_parent_layer_code',
    },
    {
      title: 'ui_offset_x',
      source: 'ui_offset_x',
      ttoken: 'admin:layers.offset_x',
      type: 'numeric',
      tooltip: 'admin:layers.help.ui_offset_x',
    },
    {
      title: 'ui_offset_y',
      source: 'ui_offset_y',
      ttoken: 'admin:layers.offset_y',
      type: 'numeric',
      tooltip: 'admin:layers.help.ui_offset_y',
    },
    {
      title: 'ui_style',
      source: 'ui_style',
      ttoken: 'admin:layers.style',
      type: 'text',
      validation: {
        maxLength: 100,
      },
      tooltip: 'admin:layers.help.ui_style',
    },
    {
      title: 'gs_timeseries',
      source: 'gs_timeseries',
      ttoken: 'admin:layers.timeseries',
      type: 'text',
      validation: {
        maxLength: 500,
      },
      tooltip: 'admin:layers.help.gs_timeseries',
    },
    {
      title: 'gs_visible_min_zoom',
      source: 'gs_visible_min_zoom',
      ttoken: 'admin:layers.visible_min_zoom',
      type: 'numeric',
      tooltip: 'admin:layers.help.gs_visible_min_zoom',
    },
    {
      title: 'gs_visible_max_zoom',
      source: 'gs_visible_max_zoom',
      ttoken: 'admin:layers.visible_max_zoom',
      type: 'numeric',
      tooltip: 'admin:layers.help.gs_visible_max_zoom',
    },
    {
      title: 'ui_legend',
      source: 'ui_legend',
      ttoken: 'core:common.legend',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: true,
      },
      tooltip: 'admin:layers.help.ui_legend',
    },
    {
      title: 'legend_conf_id',
      source: 'legend_conf_id',
      ttoken: 'admin:layers.legend_conf_id',
      filter: true,
      type: 'picker',
      subModel: {
        apiPath: 'system/map_legend_conf?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      tooltip: 'admin:layers.help.legend_conf_id',
    },
    {
      title: 'gfi_model_id',
      source: 'gfi_model_id',
      ttoken: 'admin:common.model_id',
      type: 'picker',
      subModel: {
        apiPath: 'system/models?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      readonly: true,
      translate: false,
      filter: true,
      tooltip: 'admin:layers.help.gfi_model_id',
    },
    {
      title: 'ui_has_opacity_slider',
      source: 'ui_has_opacity_slider',
      ttoken: 'admin:layers.has_opacity_slider',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      tooltip: 'admin:layers.help.ui_has_opacity_slider',
    },
    {
      title: 'layer_functionality_id',
      source: 'layer_functionality_id',
      ttoken: 'admin:layers.layer_functionality',
      type: 'picker',
      translate: true,
      subModel: {
        apiPath: 'core/layer-functionalities?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      filter: true,
      tooltip: 'admin:layers.help.layer_functionality_id',
    },
    {
      title: 'module_id',
      source: 'module_id',
      ttoken: 'admin:layers.modules',
      type: 'picker',
      translate: true,
      subModel: {
        apiPath: 'system/app_modules?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      filter: true,
      tooltip: 'admin:layers.help.module_id',
    },
    {
      title: 'app_permission_id',
      source: 'app_permission_id',
      ttoken: 'admin:layers.permissions',
      type: 'picker',
      translate: true,
      subModel: {
        apiPath: "system/app_modules/0/app_permissions?view=picker",
        format: "{label}",
        idattr: 'id',
      },
      filter: true,
      tooltip: 'admin:layers.help.app_permission_id',
    },
    {
      title: 'current_app_permission_id',
      source: 'current_app_permission_id',
      ttoken: 'admin:layers.permissions',
      type: 'picker',
      translate: true,
      subModel: {
        apiPath: 'system/app_permissions?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      filter: true,
      tooltip: 'admin:layers.help.current_app_permission_id',
    },
  ],
};

export default MapLayer;
